import AddIcon from '@mui/icons-material/Add';
import { Button, Stack, Tooltip, Typography } from '@mui/material';

import type { SectionHeaderProps } from '../types';

export const SectionHeader = ({ label, count, action }: SectionHeaderProps) => {
  const startIcon =
    action?.startIcon === undefined ? <AddIcon fontSize="small" /> : action?.startIcon ?? undefined;

  const labelText = count !== undefined ? `${label} (${count})` : label;

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="h6" component="h3">
        {labelText}
      </Typography>
      {action && (
        <Tooltip title={action.tooltip ?? ''} disableHoverListener={!action.tooltip}>
          {/* span wrapper so the tooltip still shows when the button is disabled */}
          <span>
            <Button
              variant="outlined"
              size="small"
              onClick={action.onClick}
              disabled={action.disabled}
              startIcon={startIcon}
              sx={{ textTransform: 'none' }}
              data-testid={action.dataTestId}
            >
              {action.label}
            </Button>
          </span>
        </Tooltip>
      )}
    </Stack>
  );
};
